import Dropdown from "react-bootstrap/Dropdown";
import { AiOutlinePlus } from "react-icons/ai";

const DropDownButon = ({ onClick, title,submitandopenmodalform, isAdding }) => {
  return (
    <div className="dropdown-buttons">
      <button
        type="button"
        disabled={isAdding}
        className="btn btn muBtn outline-none"
          onClick={(evt) => {submitandopenmodalform()}}
          
        >
           <AiOutlinePlus /> Save and New
        </button>
        <button
        disabled={isAdding}
          onClick={(evt) => {evt.stopPropagation();}}
          
          className="btn btn __blue btn muBtn _blue"
        >
          Save and Close
        </button>
      
    </div>
  );
  
};

export default DropDownButon;
